import { _ as r } from "../internals/export.js";
import { g as t } from "../internals/get-built-in.js";
import { f as n } from "../internals/function-apply.js";
import { f as o } from "../internals/fails.js";
import { w as s } from "../internals/wrap-error-constructor-with-cause.js";
var a = "AggregateError",
  e = t(a),
  i = !o(function () {
    return 1 !== e([1]).errors[0];
  }) && o(function () {
    return 7 !== e([1], a, {
      cause: 7
    }).cause;
  });
r({
  global: !0,
  constructor: !0,
  arity: 2,
  forced: i
}, {
  AggregateError: s(a, function (r) {
    return function (t, o) {
      return n(r, this, arguments);
    };
  }, i, !0)
});